import React, { useState, useEffect } from 'react';
import { formatDuration } from '../../utils/formatters';

interface TimerProps {
  endsAt: Date;
}

export const Timer: React.FC<TimerProps> = ({ endsAt }) => {
  const [timeRemaining, setTimeRemaining] = useState('');

  useEffect(() => {
    const updateTimer = () => {
      const now = Date.now();
      const end = endsAt.getTime();
      const diff = end - now;

      if (diff <= 0) {
        setTimeRemaining('Ended');
        return;
      }

      setTimeRemaining(formatDuration(diff));
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [endsAt]);

  return (
    <span className="market-stat market-timer">
      Closes in <span className="timer-value">{timeRemaining}</span>
    </span>
  );
};
